import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "animate.css";
import axios from "axios";

const Slidere = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchBanners = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/banner_list`
      );

      if (data?.result) {
        setBanners(data.data);
      } else {
        setError("No banner found");
      }
    } catch (err) {
      setError("Failed to load banners");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);

  const settings = {
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true, // ✅ ENABLED DOTS
    arrows: true,
    // prevArrow: <CustomPrevArrow />,
    // nextArrow: <CustomNextArrow />,
    responsive: [
      { breakpoint: 992, settings: { slidesToShow: 1 } },
      { breakpoint: 576, settings: { slidesToShow: 1 } },
    ],
  };

  if (loading) return <p style={{ textAlign: "center" }}>Loading banners...</p>;
  if (error) return <p style={{ textAlign: "center", color: "red" }}>{error}</p>;

  return (
    <div style={{ position: "relative", zIndex: 0 }}>
      <div
        className="maintext"
        style={{
          zIndex: 0,
          boxShadow: "0 4px 2px -2px rgba(0, 0, 0, 0.2)",
        }}
      >
        <Slider {...settings}>
          {banners?.map((item, index) => (
            <div key={index}>
              <img
                className="bannerimg"
                src={`${process.env.REACT_APP_API}uploads/${item.banner_image}`}
                height="450px"
                width="100%"
                style={{ objectFit: "cover" }}
                alt={`Banner ${index + 1}`}
                onError={(e) => (e.target.src = "/fallback-banner.jpg")}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Slidere;
